const AllProductsOnTabs = {};

export default AllProductsOnTabs